import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import * as api from '../api/business-settings';
import { useBusinessUuid } from '../useBusinessUuid';

export const useBusinessSettings = () => {
  const businessUuid = useBusinessUuid();
  return useQuery({
    queryKey: ['business-settings', businessUuid],
    queryFn: () => api.getBusinessSettings(businessUuid),
    enabled: !!businessUuid,
  });
};

export const useUpdateBusinessSettings = () => {
  const qc = useQueryClient();
  const businessUuid = useBusinessUuid();
  return useMutation({
    mutationFn: (data) => {
      if (!businessUuid) throw new Error('Business UUID is required');
      return api.updateBusinessSettings(businessUuid, data);
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: ['business-settings'] }),
  });
};
